import { render, staticRenderFns } from "./PartialPaymentDetail.vue?vue&type=template&id=5a482e36"
import script from "./PartialPaymentDetail.vue?vue&type=script&lang=js"
export * from "./PartialPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports